import { useState, useEffect } from 'react';

let cachedStations = null;
let fetchPromise = null;

export function useGrandEstStations() {
  const [stations, setStations] = useState(cachedStations || []);

  useEffect(() => {
    if (cachedStations) {
      setStations(cachedStations);
      return;
    }
    if (!fetchPromise) {
      fetchPromise = fetch('/api/grand-est-stations')
        .then(r => r.json())
        .then(d => {
          cachedStations = d.stations || [];
          return cachedStations;
        })
        .catch(() => {
          fetchPromise = null;
          return [];
        });
    }
    fetchPromise.then(s => setStations(s));
  }, []);

  const isGrandEst = (str) =>
    stations.some(g =>
      (str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(g)
    );

  return { isGrandEst, stations, loaded: stations.length > 0 };
}
